import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-inset-text" }, [
  /*#__PURE__*/_createTextVNode(" This service is for England and Wales only. There's a different process in "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "govuk-link",
    href: "https://www.nrscotland.gov.uk/research/guides/wills-and-testaments"
  }, "Scotland"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "govuk-link",
    href: "http://www.proni.gov.uk/"
  }, "Northern Ireland"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Heading),
    _hoisted_1,
    _createVNode(_component_Form, {
      fieldsets: _ctx.fieldsets,
      fields: _ctx.fields,
      buttons: _ctx.buttons,
      onFormHasPassedValidation: _ctx.saveFormData
    }, null, 8, ["fieldsets", "fields", "buttons", "onFormHasPassedValidation"])
  ], 64))
}